import React, { createContext, useContext, useState } from 'react';

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLang] = useState(
    () => localStorage.getItem('monitgps_lang') || 'pl'
  );

  const setLanguage = (lang) => {
    setLang(lang);
    localStorage.setItem('monitgps_lang', lang);
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
